import { useContext } from "react";
import { modalCargando, mensajeSimple } from "../../components/ui/sweetAlerts";
import { hideSideBarDesktop, validaGetStatus } from "../../utils/funciones";
import { put } from "../../api/apis";
import { DataContextContractual } from "../../contextData/contextData";

export const useAjustesDias = () => {
  const { ObtenerDiasAnticipacion } = useContext(DataContextContractual);

  const enviar = async (id, dias) => {
    modalCargando("Guardando cambios...");
    const resp = await put('configuracion', null, { id: Number(id), dias_anticipacion: Number(dias) });
    hideSideBarDesktop();

    if (!validaGetStatus(resp)) {
      mensajeSimple('error', "Error al guardar cambios", 2500);
      return;
    }
    mensajeSimple('success', 'Guardado Listo!', 1000);
    if (ObtenerDiasAnticipacion) {
      await ObtenerDiasAnticipacion();
    }
  };

  return {
    enviar,
  };
};